// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"ListReports_status-icon__F9i6N"};